<template>
<div>
    <official-fee-payment-institution-list></official-fee-payment-institution-list>
</div>
</template>

<script>
export default {};
</script>
